module.exports = __webpack_public_path__ + "assets/img/thumb-SRG-Finance-Pillar-Page-Resource.d35a856d.webp";